import * as React from 'react';

function SvgBoardBell(props) {
  return (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.75 12h-.375V6.687a4.376 4.376 0 00-3.75-4.33V1.75a.625.625 0 10-1.25 0v.606a4.376 4.376 0 00-3.75 4.332V12H3.25a.5.5 0 00-.5.5v.5c0 .069.056.125.125.125H6.25a1.751 1.751 0 003.5 0h3.375A.125.125 0 0013.25 13v-.5a.5.5 0 00-.5-.5zM8 13.875a.75.75 0 01-.75-.75h1.5a.75.75 0 01-.75.75z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgBoardBell;
